import React from 'react';
import {SunDim} from "@phosphor-icons/react";

const IconDay = (props) => (
    <SunDim {...props}/>
);

export default IconDay;